import React from 'react'
import { Recepcionar } from '@newspacebpo/mf_protocolo_bfveic'

const RecepcionarPage = (props) => {
    return (
        <Recepcionar {...props}/>
    );
};

export { RecepcionarPage };